import React, { useState } from 'react';

import { useMapContext } from 'shared/context';
import { MAP } from 'shared/constants';
import { Button, Flex, Input, Section } from 'components';

export const Coords = () => {
  const { lat, setLat, long, setLong, map, terrain, summary } = useMapContext();
  const [customLat, setCustomLat] = useState<number>(0);
  const [customLong, setCustomLong] = useState<number>(0);
  const error = () => alert('Unable to retrieve your location');
  const success = (position: GeolocationPosition) => {
    if (!map) return;
    const newLat = position.coords.latitude;
    const newLong = position.coords.longitude;
    map.setView([newLat, newLong], MAP.ZOOM);
    setLat(newLat);
    setLong(newLong);
  };

  const onCustomPositionClick = () => {
    if (!map) return;
    setLat(customLat);
    setLong(customLong);
    map.setView([customLat, customLong], MAP.ZOOM);
    setCustomLat(0);
    setCustomLong(0);
  };

  const onMyPositionClick = () => {
    if (!navigator.geolocation) {
      alert('Geolocation is not supported by your browser');
    } else {
      navigator.geolocation.getCurrentPosition(success, error);
    }
  };
  return (
    <Section column>
      <h2>
        Coordinates: {lat}, {long}
      </h2>
      <h3>Terrain: {terrain}</h3>
      <h3>Summary: {summary}</h3>
      <Flex row $wrap style={{ margin: '8px 0' }}>
        <Input
          placeholder="lat"
          value={customLat}
          onChange={event => setCustomLat(Number(event.target.value))}
        />
        <Input
          placeholder="long"
          value={customLong}
          onChange={event => setCustomLong(Number(event.target.value))}
        />
      </Flex>
      <Flex row $wrap style={{ margin: '4px 0' }}>
        <Button onClick={onCustomPositionClick}>Choose position</Button>
        <Button onClick={onMyPositionClick} style={{ marginLeft: '8px' }}>
          Snap to my position
        </Button>
      </Flex>
    </Section>
  );
};
